import React, { useMemo } from 'react';

import {
    DirectionEnum,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    Popover,
    Switch,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

import { MobilePlanType } from '@app-types/plan';

import { LockedPlanValue } from '@helpers/plan-lock';

interface LockedPlanSwitchProps {
    id: string;
    offer: MobilePlanType;
    checked: boolean;
    onChange: () => void;
}

export function LockedPlanSwitch({ id, offer, checked, onChange }: Readonly<LockedPlanSwitchProps>) {
    const isForceLocked = useMemo(() => {
        return offer.locked === LockedPlanValue.LOCK_FORCED;
    }, [offer.locked]);

    if (offer.locked === LockedPlanValue.UNLOCK) {
        return;
    }

    return (
        <Switch
            id={id}
            label={
                (
                    <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.ONE}>
                        <Text
                            level={TextLevels.TWO}
                            typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                            marginless
                            className='is-flex is-aligned-center gap-small'
                        >
                            Forfait bloqué
                            {!isForceLocked && (
                                <span
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                >
                                    <Popover trigger={<Icon name={IconName.INFOS_CIRCLE} />}>
                                        <Text typo={TypographyAlign.TEXT_LEFT}>
                                            Vous pouvez activer ou désactiver l&apos;option Forfait bloqué gratuitement
                                            et à tout moment depuis votre application Bouygues Telecom ou votre espace
                                            client.
                                        </Text>
                                    </Popover>
                                </span>
                            )}
                        </Text>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_NORMAL} marginless>
                            Pour bloquer le hors forfait.
                        </Text>
                    </FlexBox>
                ) as unknown as string // TODO : Clean après update trilogy
            }
            value={offer.entityId}
            checked={checked || isForceLocked}
            disabled={isForceLocked}
            reversed
            onChange={onChange}
        />
    );
}
